"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatsPanel = void 0;
const stats_js_1 = __importDefault(require("stats.js"));
class StatsPanel {
    constructor() {
        this.stats = new stats_js_1.default();
    }
    begin() {
        this.stats.begin();
    }
    end() {
        this.stats.end();
    }
    getParentElement() {
        return this.stats.dom.parentElement;
    }
    addPanel() {
        document.body.appendChild(this.stats.dom);
    }
    removePanel() {
        document.body.removeChild(this.stats.dom);
    }
    showPanel(panel) {
        this.stats.showPanel(panel); // 0: fps, 1: ms, 2: mb, 3+: custom
    }
}
exports.StatsPanel = StatsPanel;
//# sourceMappingURL=stats.js.map